export interface IAccount {
  id: number;
  agents: { account: string; cashback: number }[];
  account: string;
  mining_terms: { cashback?: number; discount?: number } | null;
  override_started_date: string | null;
  region: string;
  note: string | null;
  minimal_pay_hashrate: number;
  account_type: ACCOUNT_TYPE;
  created_at: string;
  updated_at: string;
  is_processed: boolean;
  client: { value: string; label: string };
  managers: { value: string; label: string }[];
  tags: { value: string; label: string } | null;
  source: { value: string; label: string } | null;
  discount: number;
  // info fields
  hashrate: number;
  reward: number;
  days: number;
  terms: number;
  referral_interest: number;
  client_id: number;
  client_name: string;
  client_tags: string;
  client_source: string;
  client_out_of_flex: boolean;
  is_new: boolean;
  override_is_new: boolean;
  manager_name: string;
}

export enum ACCOUNT_TYPE {
  AGENT = 'AGENT',
  REFERRAL = 'REFERRAL',
  MINING = 'MINING',
}
